import { FaRegFileImage, FaRegPlayCircle, FaRegFile } from 'react-icons/fa';
import { GrDocumentPdf } from 'react-icons/gr';

import { PaperlessCubeIcon, createIcon } from '@frontend/components';

import {
  CAD_FILE_TYPES,
  IMG_FILE_TYPES,
  PDF_FILE_TYPES,
  VIDEO_FILE_TYPES,
} from 'constants/all';

const BaseFileIcon = createIcon(FaRegFile, 'BaseFileIcon');
const PdfIcon = createIcon(GrDocumentPdf, 'PDFIcon');
const ImageIcon = createIcon(FaRegFileImage, 'ImageIcon');
const VideoIcon = createIcon(FaRegPlayCircle, 'VideoIcon');

const FileTypeIcon = ({ fileType, ...rest }) =>
  Object.values(CAD_FILE_TYPES).includes(fileType) ? (
    <PaperlessCubeIcon {...rest} />
  ) : Object.values(PDF_FILE_TYPES).includes(fileType) ? (
    <PdfIcon {...rest} />
  ) : Object.values(IMG_FILE_TYPES).includes(fileType) ? (
    <ImageIcon {...rest} />
  ) : Object.values(VIDEO_FILE_TYPES).includes(fileType) ? (
    <VideoIcon {...rest} />
  ) : (
    <BaseFileIcon {...rest} />
  );

export default FileTypeIcon;
